import * as React from "react";
import ApiKeyManagement from "../../Hub/Tabs/ApiKeyManagement";

const ProjectApiKeyManagement = () => {
    return (
        <ApiKeyManagement/>
    )
}

export default ProjectApiKeyManagement;